"use client";

import { useEffect } from "react";

import * as Sentry from "@sentry/nextjs";
import { env } from "env";
import posthog from "posthog-js";

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    console.error("global-error", error);
    Sentry.captureException(error);
    posthog.captureException(error, {
      environment: env.NEXT_PUBLIC_POSTHOG_ENVIRONMENT,
    });
  }, [error]);

  return (
    <html>
      <body>
        <main className="flex min-h-screen items-center justify-center px-6 text-center">
          <div>
            <h2 className="text-xl font-semibold">Something went wrong</h2>
            <p className="text-muted-foreground mt-2 text-sm">
              An unexpected error occurred. Please refresh the page and try again.
            </p>
          </div>
        </main>
      </body>
    </html>
  );
}
